<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="tarefas"
      :sort-by="[{ key: 'titulo', order: 'asc' }]"
      :search="search"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.push('/projects')"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >{{ this.nomeProjeto ? `${this.nomeProjeto + ' -'}` : '' }} Backlog
            de Tarefas</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <div
            :class="{ flex: isDev || isCoord, 'flex-20': !(isDev || isCoord) }"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              outline
              hide-details
              variant="underlined"
              style="width: 40%"
            ></v-text-field>
            <ModalCadastrarTarefa
              v-if="isDev || isCoord"
              style="margin-right: 40px"
              :id-projeto="parseInt(this.$route.params.id)"
            />
          </div>
        </v-toolbar>

        <!-- Visualizar Tarefa -->
        <v-dialog v-model="dialogView" max-width="480px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-label>Título</v-label>
                    <p>{{ visualizarItem.titulo }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Status da Tarefa</v-label>
                    <p>{{ visualizarItem.status_tarefa }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Prioridade</v-label>
                    <p>{{ visualizarItem.prioridade }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Tipo da Tarefa</v-label>
                    <p>{{ visualizarItem.tipo_tarefa }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Story Points</v-label>
                    <p>{{ visualizarItem.storypoint }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Data Início</v-label>
                    <p>{{ formatarData(visualizarItem.dt_inicio) }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-label>Data Fim</v-label>
                    <p>{{ formatarData(visualizarItem.dt_fim) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-label>Número da Issue</v-label>
                    <p>{{ visualizarItem.numero_issue }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-label>Sprints</v-label>
                    <v-list
                      class="d-flex flex-wrap"
                      :min-width="150"
                      lines="one"
                      v-if="visualizarItem.tb_itembacklogsprint.length > 0"
                    >
                      <!-- eslint-disable -->
                      <v-list-item
                        v-for="sprint in visualizarItem.tb_itembacklogsprint"
                        :key="sprint.tb_sprint.id_sprint"
                        :title="`Sprint ${sprint.tb_sprint.numero_sprint}`"
                        :subtitle="`Data Inicial: ${formatarData(
                          sprint.tb_sprint.dt_inicio
                        )} | Data Final: ${formatarData(
                          sprint.tb_sprint.dt_fim
                        )}`"
                        elevation="2"
                        class="sprint-item"
                      >
                      </v-list-item>
                      <!-- eslint-enable -->
                    </v-list>
                    <p v-else>
                      <strong>Não definida em nenhuma sprint.</strong>
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-label>Descrição</v-label>
                    <p>
                      {{
                        visualizarItem.descricao != ''
                          ? visualizarItem.descricao
                          : 'Sem descrição'
                      }}
                    </p>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialogView = false"
                  >
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Definir Tarefa -->
        <v-dialog v-model="showModalDefinirTarefa" width="480">
          <v-card>
            <v-card-text>
              <v-card-title>
                <span>Definir sprint</span>
              </v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="8" md="12">
                    <v-select
                      variant="underlined"
                      v-model="sprintDefinida"
                      label="Sprints"
                      :items="sprints"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="this.showModalDefinirTarefa = false"
              >
                Cancelar
              </v-btn>
              <v-btn color="blue-darken-1" variant="text" @click="defineTask">
                Definir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="justify-content-center">
          <v-tooltip text="Visualizar tarefa" location="bottom">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                size="small"
                class="me-2"
                @click="showItem(item.raw)"
              >
                mdi-eye
              </v-icon>
            </template>
          </v-tooltip>
          <v-tooltip text="Definir Sprint" location="bottom">
            <template #activator="{ props }">
              <v-icon
                v-bind="props"
                size="small"
                class="me-2"
                @click="defineItem(item.raw)"
              >
                mdi-sign-direction
              </v-icon>
            </template>
          </v-tooltip>
        </div>
      </template>

      <template #no-data>
        <div class="text-center py-6">
          <span> Sem tarefas a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import ModalCadastrarTarefa from '@/components/dialogs/ModalCadastrarTarefa.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    ModalCadastrarTarefa,
    SnackBar,
  },
  data: () => ({
    headers: [
      { title: 'Tarefa', align: 'start', key: 'titulo' },
      { title: 'Tipo da Tarefa', key: 'tipo_tarefa' },
      { title: 'Prioridade', key: 'prioridade' },
      { title: 'Story points', key: 'storypoint' },
      { title: 'Status', key: 'status_tarefa' },
      { title: 'Issue', key: 'numero_issue' },
      { title: 'Sprint', key: 'sprint' },
      { title: 'Ações', key: 'actions', sortable: false },
    ],
    tarefas: [],
    sprints: [],
    idTarefa: null,
    objetoFormaAtuacao: null,
    atuacao: null,
    nomeProjeto: undefined,
    search: '',
    dialogView: false,
    showModalDefinirTarefa: false,
    index: -1,
    sprintDefinida: null,
    sprintTitle: [],
    /*eslint-disable*/
    visualizarItem: {
      titulo: '',
      descricao: '',
      dt_inicio: '',
      dt_fim: '',
      numero_issue: '',
      storypoint: '',
      prioridade: '',
      status_tarefa: '',
      tipo_tarefa: '',
      tb_itembacklogsprint: [],
    },
    /* eslint-enable */
  }),

  async created() {
    this.fetchProjeto();
    this.fetchTarefas();
    this.fetchSprints();
  },
  mounted() {
    this.objetoFormaAtuacao = JSON.parse(
      localStorage.getItem('formaAtuacaoProjeto'),
    );
    this.objetoFormaAtuacao.forEach((element) => {
      if (
        element.id_projeto.some(
          (idProjeto) => idProjeto == this.$route.params.id,
        )
      ) {
        this.atuacao = element.forma_atuacao;
      }
    });
    localStorage.setItem('formaAtuacao', JSON.stringify(this.atuacao));
  },

  computed: {
    isDev() {
      return localStorage.getItem('funcao') === 'Desenvolvedor';
    },
    isCoord() {
      return localStorage.getItem('funcao') === 'Coordenador';
    },
    isScrum() {
      return localStorage.getItem('funcao') === 'Scrum Master';
    },
  },

  methods: {
    defineItem(item) {
      this.idTarefa = parseInt(item.id_tarefa);
      this.showModalDefinirTarefa = true;
    },
    showItem(item) {
      this.index = this.tarefas.indexOf(item);
      this.visualizarItem = Object.assign({}, item);
      this.dialogView = true;
      console.log(item);
    },
    formatarData(data) {
      if (data == null) {
        return 'Não definida';
      }
      const dataObj = new Date(data);
      const dia = dataObj.getDate().toString().padStart(2, '0');
      const mes = (dataObj.getMonth() + 1).toString().padStart(2, '0');
      const ano = dataObj.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
    fetchSprints() {
      axios
        .get(API_URL + `/sprints/projeto/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.sprints.push(element.titulomilestone);
          });
        });
    },
    fetchTarefas() {
      const result = axios.get(
        API_URL + `/tarefas/backlog/${this.$route.params.id}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      );
      result
        .then((response) => {
          const tarefas = response.data.map((tarefa) => ({
            ...tarefa,
            sprint:
              tarefa.tb_itembacklogsprint.length > 0
                ? tarefa.tb_itembacklogsprint.length > 1
                  ? 'Múltiplas Sprints'
                  : tarefa.tb_itembacklogsprint[0].tb_sprint.titulomilestone
                : 'Não definida',
          }));

          this.tarefas = tarefas;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchProjeto() {
      axios
        .get(API_URL + `/projetos/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.nomeProjeto = response.data.nome;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    defineTask() {
      const data = { titulomilestone: this.sprintDefinida };
      console.log(data);
      axios
        .post(API_URL + `/tarefas/definir/${parseInt(this.idTarefa)}`, data, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Sua tarefa foi definida com sucesso!',
          );
          location.reload();
        })
        .catch((error) => {
          console.log(error.response.data.error);
          this.$refs.snackbar.showErrorSnackbar(
            'Hm... Algo deu errado',
            `${error.response.data.error}`,
          );
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  width: 50%;
  align-items: center;
}
.flex-20 {
  display: flex;
  width: 20%;
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.d-flex {
  display: flex;
  padding: 0;
}
.sprint-item {
  width: 97%;
  padding: 10px;
  margin: 10px 5px;
}
</style>
